import moment from 'moment';

import Box from '@mui/material/Box';
import CircleIcon from '@mui/icons-material/Circle';
import CalendarIcon from '@mui/icons-material/CalendarToday';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SettingsIcon from '@mui/icons-material/Settings';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const AvailabilityListItem = ({
  availability, 
  onClick
}) => {
  const sessionTypeCount = availability?.configs?.length || 0;
  const firstDayAvailability = availability.day_availabilities?.[0];
  const startTime =
    firstDayAvailability 
      ? moment()
        .startOf('day')
        .add(firstDayAvailability.start_minute, 'minutes')
        .format('h:mm A') 
      : '';
  const endTime =
    firstDayAvailability 
      ? moment()
        .startOf('day')
        .add(firstDayAvailability.end_minute, 'minutes')
        .format('h:mm A') 
      : '';
  return (
    <Box 
      style={{
        borderRadius: '5px',
        border: '1px solid rgb(240,240,240)', 
        padding: '1em', 
        cursor: 'pointer',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
      }}
      sx={{
        '&:hover': {backgroundColor: 'rgb(245,245,245)'}
      }}
      onClick={onClick}
    >
      <Stack spacing={.5}>
        <Stack direction='row' spacing={1}>
          <CircleIcon 
            fontSize='xs' 
            style={{color: availability.css_color, marginTop: "0.25em"}} 
          />
          <Stack>
            <Typography variant="h2">{availability.title}</Typography>
            <Stack direction='row' spacing={1} alignItems='center'>
              <CalendarIcon fontSize='xs' sx={{color: 'text.muted'}} />
              <Typography variant='body1' color='text.muted'>
                {availability.day_availabilities.reduce(
                  (acc, day, i) => acc + (i === 0 ? '' : ', ') + day.day, 
                  ''
                )}
              </Typography>
            </Stack>
            <Stack direction='row' spacing={1} alignItems='center'>
              <ScheduleIcon fontSize='xs' sx={{color: 'text.muted'}} />
              <Typography variant="caption" color="text.muted">
                {startTime} - {endTime}
              </Typography>
            </Stack>
            <Stack direction='row' spacing={1} alignItems='center'>
              <SettingsIcon fontSize='xs' sx={{color: 'text.muted'}} />
              <Typography variant="body1" color="text.muted">
                {sessionTypeCount} session type{sessionTypeCount !== 1 ? 's' : ''}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

export default AvailabilityListItem;